import { PersonRequest } from "@plinknz/tah-website-elements";
import { personalDetailsConfig } from "./config-generics/personal-details";
import { signatureConfig } from "./config-generics/signature";
import { PageConfig } from "../../components/content-blocks/forms/customer-form-types";
import { UserData } from "../reducers/user";
import { overviewConfig } from "./config-generics/overview";

export const createSurveyConfig = (member: PersonRequest, user?: UserData) => {
    const personalConfig = personalDetailsConfig({
        member,
        children: user.onSameEmail,
    });

    const overviewDetailsConfig = overviewConfig({
        heading: "Tahua Taumaru | Emergency/ Discretionary Grant",
        content: [
            {
                heading: "Overview",
                lines: [
                    `Provides immediate financial support for whānau of Ngāti
                    Kuia facing urgent or unforeseen circumstances. This grant
                    is intended to assist with critical needs or unexpected
                    events that require prompt assistance.`,
                ],
            },
            {
                heading: "Eligibility",
                lines: [
                    "To apply for this grant, you must:",
                    [
                        "Be a registered member of Ngāti Kuia",
                        "Provide proof of expense (e.g. invoice, statement).",
                        "Briefly explain your circumstances and why urgent support is required.",
                        "Submit any supporting documentation relevant to your application (e.g., overdue invoices, insurance excess, etc.).",
                    ],
                ],
            },
            {
                heading: "Key Dates & Deadlines",
                lines: [
                    [
                        "Deadline: Applications can be submitted anytime, and decisions are made as quickly as possible to ensure timely support.",
                        "Payment: Grants are typically paid directly to the service provider or towards the bill. In select circumstances, payment may be made directly to the applicant.",
                    ],
                ],
            },
            {
                heading: "Funding Available",
                lines: [
                    "The minimum is $75. The total amount awarded varies depending on the level of need and the cost of the expense.",
                ],
            },
            {
                heading: "Documents You'll Need",
                lines: [["Proof of the expense."]],
            },
        ],
    });

    const otherConfig: PageConfig[] = [
        {
            name: "circumstances",
            title: "Circumstances - Tōu Kōrero",
            questions: [
                {
                    name: "circumstances",
                    title:
                        "Briefly explain your circumstances and why urgent support is required",
                    placeHolder: "Tōu Kōrero",
                    type: "comment",
                    isRequired: true,
                },
                {
                    type: "file",
                    name: "expenses",
                    title:
                        "Please upload proof of expenses (e.g invoice, statement)",
                    storeDataAsText: false,
                    allowMultiple: true,
                    maxSize: 10485760,
                    waitForUpload: true,
                    startWithNewLine: true,
                    isRequired: true,
                },
                {
                    type: "file",
                    name: "attachments",
                    title:
                        "Please upload any supporting documentation relevant to your application (e.g. overdue invoices, insurance excess, etc.)",
                    storeDataAsText: false,
                    allowMultiple: true,
                    maxSize: 10485760,
                    waitForUpload: true,
                    startWithNewLine: true,
                    isRequired: true,
                },
            ],
        },
    ];

    const pages: PageConfig[] = [
        ...overviewDetailsConfig,
        ...personalConfig,
        ...otherConfig,
        ...signatureConfig,
    ];

    return { pages };
};
